"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { FiSearch, FiX } from "react-icons/fi";
import { TestIdEnum } from "../../../tests/types";
import type { Option } from "../../types/selects";
interface MultiSelectFilterProps {
  title: string;
  options: Option[];
  selected: string[];
  onChange: (selected: string[]) => void;
}
export const MultiSelectFilter = t0 => {
  const $ = _c(44);
  const {
    title,
    options,
    selected,
    onChange
  } = t0;
  const [searchQuery, setSearchQuery] = useState("");
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== onChange || $[1] !== options || $[2] !== searchQuery || $[3] !== selected || $[4] !== title) {
    let t7;
    if ($[11] !== searchQuery) {
      t7 = opt => opt.label.toLowerCase().includes(searchQuery.toLowerCase());
      $[11] = searchQuery;
      $[12] = t7;
    } else {
      t7 = $[12];
    }
    const filteredOptions = options.filter(t7);
    let t8;
    if ($[13] !== onChange || $[14] !== selected) {
      t8 = optionValue => {
        const newSelected = selected.includes(optionValue) ? selected.filter(item => item !== optionValue) : [...selected, optionValue];
        onChange(newSelected);
      };
      $[13] = onChange;
      $[14] = selected;
      $[15] = t8;
    } else {
      t8 = $[15];
    }
    const toggleOption = t8;
    let t9;
    if ($[16] !== onChange || $[17] !== selected) {
      t9 = optionValue_0 => {
        onChange(selected.filter(item_0 => item_0 !== optionValue_0));
      };
      $[16] = onChange;
      $[17] = selected;
      $[18] = t9;
    } else {
      t9 = $[18];
    }
    const removeTag = t9;
    let t10;
    if ($[19] !== title) {
      t10 = title.toLowerCase();
      $[19] = title;
      $[20] = t10;
    } else {
      t10 = $[20];
    }
    const filterId = t10;
    t3 = `${TestIdEnum.FiltersMultiPrefix}-${filterId}`;
    t4 = "space-y-2";
    if ($[21] !== filterId || $[22] !== onChange || $[23] !== options || $[24] !== removeTag || $[25] !== selected) {
      t5 = selected.length > 0 && <div className="flex flex-wrap gap-1.5 mb-3">{selected.map(item_1 => <span key={item_1} data-testid={`${TestIdEnum.FiltersTagPrefix}-${item_1}`} className="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-bold bg-brand-100 dark:bg-brand-900/30 text-brand-700 dark:text-brand-400 border border-brand-200 dark:border-brand-800">{options.find(o => o.value === item_1)?.label || item_1}<button onClick={e => {
            e.stopPropagation();
            removeTag(item_1);
          }} className="ml-1 hover:text-red-500 focus:outline-none"><FiX className="w-3 h-3" /></button></span>)}{selected.length > 0 && <button onClick={() => onChange([])} data-testid={`${TestIdEnum.FiltersMultiClearPrefix}-${filterId}`} className="text-[10px] text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 underline">Wyczyść</button>}</div>;
      $[21] = filterId;
      $[22] = onChange;
      $[23] = options;
      $[24] = removeTag;
      $[25] = selected;
      $[26] = t5;
    } else {
      t5 = $[26];
    }
    const t11 = `Szukaj ${filterId}...`;
    let t12;
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
      t12 = e_0 => setSearchQuery(e_0.target.value);
      $[27] = t12;
    } else {
      t12 = $[27];
    }
    const t13 = `${TestIdEnum.FiltersInputPrefix}-${filterId}`;
    let t14;
    if ($[28] !== searchQuery || $[29] !== t11 || $[30] !== t13) {
      t14 = <input type="text" placeholder={t11} value={searchQuery} onChange={t12} data-testid={t13} className="w-full p-2 pl-2 pr-8 text-xs bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-md focus:border-brand-500 focus:ring-1 focus:ring-brand-500 outline-none dark:text-white placeholder-slate-400 focus:z-10" />;
      $[28] = searchQuery;
      $[29] = t11;
      $[30] = t13;
      $[31] = t14;
    } else {
      t14 = $[31];
    }
    let t15;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
      t15 = <div className="absolute right-2 top-1/2 -translate-y-1/2 pointer-events-none"><FiSearch className="w-3 h-3 text-slate-400" /></div>;
      $[32] = t15;
    } else {
      t15 = $[32];
    }
    if ($[33] !== t14) {
      t6 = <div className="relative mb-2">{t14}{t15}</div>;
      $[33] = t14;
      $[34] = t6;
    } else {
      t6 = $[34];
    }
    t1 = "max-h-[200px] overflow-y-auto scrollbar-thin pr-1 space-y-1";
    t2 = filteredOptions.length > 0 ? filteredOptions.map(option => <label key={option.value} className="flex items-center space-x-3 cursor-pointer group py-2.5 md:py-1 hover:bg-slate-50 dark:hover:bg-slate-800/50 rounded px-1 transition-colors"><div className="relative flex items-center flex-shrink-0"><input type="checkbox" checked={selected.includes(option.value)} onChange={() => toggleOption(option.value)} className="peer w-4 h-4 appearance-none rounded border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 checked:bg-brand-600 checked:border-brand-600 transition-colors" /><svg className="absolute w-3 h-3 text-white hidden peer-checked:block pointer-events-none left-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}><path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" /></svg></div><span data-testid={`${TestIdEnum.FiltersMultiOptionPrefix}-${option.value.toLowerCase()}`} className={`text-xs md:text-sm transition-colors ${selected.includes(option.value) ? "font-bold text-brand-600 dark:text-brand-400" : "text-slate-600 dark:text-slate-300 group-hover:text-slate-900 dark:group-hover:text-white"}`}>{option.label}</span></label>) : <div className="text-center py-4 text-xs text-slate-400">Brak wyników</div>;
    $[0] = onChange;
    $[1] = options;
    $[2] = searchQuery;
    $[3] = selected;
    $[4] = title;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
  }
  let t7;
  if ($[35] !== t1 || $[36] !== t2) {
    t7 = <div className={t1}>{t2}</div>;
    $[35] = t1;
    $[36] = t2;
    $[37] = t7;
  } else {
    t7 = $[37];
  }
  let t8;
  if ($[38] !== t3 || $[39] !== t4 || $[40] !== t5 || $[41] !== t6 || $[42] !== t7) {
    t8 = <div data-testid={t3} className={t4}>{t5}{t6}{t7}</div>;
    $[38] = t3;
    $[39] = t4;
    $[40] = t5;
    $[41] = t6;
    $[42] = t7;
    $[43] = t8;
  } else {
    t8 = $[43];
  }
  return t8;
};